import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import classes from "./Carousel.module.css";
import Layout from "./Layout";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const Carousel = ({ images }) => {
  const navigate = useNavigate();
  
  // Owl Carousel Settings
  const options = {
    loop: true,
    items: 3,
    margin: 20,
    center: true, // Center the active item
    nav: true,
    autoplay: true,
    dots: true,
    autoplayTimeout: 3000, // Autoplay interval in milliseconds
    autoplayHoverPause: true,
    smartSpeed: 450,
    responsive: {
      0: {
        items: 1,
      },
      300: {
        items: 2,
      },
      600: {
        items: 3,
      },
      1000: {
        items: 4,
      },
    },
  };

  const NavigateHandler = (id) => {
    const status = Cookies.get("status");
    if (status == "1") {
      navigate(`/video/${id}`);
    } else {
      navigate('/subscribe');
    }
  };

  return (
    <Layout>
      <div className="flex justify-center items-center">
        <OwlCarousel className="owl-theme" {...options}>
          {images.map((data, i) => {
            return (
              <div key={i} onClick={() => NavigateHandler(data?.id)}>
                <div className={`${classes["image-container"]} item object-cover cursor-pointer`}>
                  <img
                    className="object-cover rounded-2xl"
                    src={data?.imageFiveUrl}
                    alt={data?.id}
                  />
                  <div className={classes["play-button"]}>&#9654;</div>
                </div>
              </div>
            );
          })}
        </OwlCarousel>
      </div>
    </Layout>
  );
};

export default Carousel;
